"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var permissionsActions = require("@caddigital/sok-reducers/lib/actions/project/permissions");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var constants_1 = require("utils/constants");
var Types = require("types");
var mapStateToProps = function (state) {
    var modifiedStatus = state.project.permissions.changes.length > 0 ||
        (state.project.permissions.modifiedNotifications !== undefined &&
            Object.values(state.project.permissions.modifiedNotifications).length > 0);
    var categoryIds = state.project.members.groups
        .filter(function (item) { return item.groups.length > 0; })
        .map(function (item) { return item.category.id; });
    var hasGroups = categoryIds.length > 0;
    return {
        hasGroups: hasGroups,
        modifiedStatus: modifiedStatus,
        permissions: state.project.permissions,
        searchString: state.project.permissions.searchString,
        modifiedNotifications: state.project.permissions.modifiedNotifications,
        includeSubfolders: state.project.permissions.includeSubfolders
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    clear: function () {
        dispatch(permissionsActions.clearState());
    },
    resetModifications: function () {
        dispatch(permissionsActions.projectFolderPermissionsReset());
    },
    toggleIncludeSubdirectories: function () {
        return dispatch(permissionsActions.toggleIncludeSubfolders());
    },
    changeSearchString: function (value) {
        return dispatch(permissionsActions.changeSearchString(value));
    },
    save: function () { return dispatch(permissionsActions.savePermissionsRequest()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var timeout = null;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('PermissionListControls'), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('search', 'setSearch', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.clear();
    },
    shouldComponentUpdate: function (nextProps) {
        var keys = Object.keys(this.props);
        var update = false;
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (this.props[key] !== nextProps[key]) {
                update = true;
            }
        }
        return update;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { key: "permissionsContent", className: "permissions-controls-container" },
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.permissions.saveStatus, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
        (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textSaving'),
        (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textSaved'),
        (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textErrorSaving')),
    React.createElement("div", { className: "permissions-controls" },
        React.createElement("div", { className: "buttons" },
            React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: 'fa-save' }), color: "base-green", disabled: !props.modifiedStatus || props.permissions.saveStatus === 'SAVING', text: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textSave'), onClick: function () { return props.save(); } }),
            React.createElement(sok_ui_1.Button, { color: "base-green", disabled: !props.modifiedStatus, text: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textReset'), onClick: function () { return props.setIsOpen(true); } })),
        React.createElement("div", { className: "folder-tree-toggle" },
            React.createElement(sok_ui_1.Input, { disabled: !props.hasGroups, type: "checkbox", value: props.includeSubfolders, onChange: props.toggleIncludeSubdirectories, label: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/includeSubs') }))),
    React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
            React.createElement(ConfirmDialog_1.Exclamation, null),
            React.createElement("div", null,
                React.createElement("div", { className: 'title please-confirm-text' },
                    React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                React.createElement("div", { className: 'text' },
                    React.createElement("p", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice1')),
                    React.createElement("p", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice2'))))), footer: React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                    props.resetModifications();
                    props.setIsOpen(false);
                } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setIsOpen(false); } })) }),
    React.createElement("div", { className: "user-groups-search" },
        React.createElement(sok_ui_1.TextInput, { disabled: !props.hasGroups, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), iconRight: props.searchString.length > 0 ? (React.createElement(Icon_1.Icon, { className: 'fa-times clear-search', onClick: function () {
                    props.changeSearchString('');
                } })) : undefined, className: 'sok-search white', placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/searchPlaceholder'), value: props.search !== null ? props.search : props.searchString, onChange: function (e) {
                var value = e.target.value;
                props.setSearch(value);
                if (timeout) {
                    clearTimeout(timeout);
                }
                if (value === '') {
                    props.setSearch(null);
                    props.changeSearchString(value);
                    return;
                }
                timeout = setTimeout(function () {
                    props.changeSearchString(value);
                    props.setSearch(null);
                }, constants_1.SEARCH_TIMEOUT);
            } })))); });
